module.exports = __webpack_public_path__ + "static/classes-top2-25af63b426ff4da2941a33ea8ae9a944.png";